import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import { ConnectedProps, connect } from "react-redux"
import QuoteItemUnitPrice from "../../common/quote/itemunitprice.component.jsx"
import InputUnitOfMeasure from "../../common/unit-of-measure/input.component"
import LabelUnitOfMeasure from "../../common/unit-of-measure/label.component"
import DiscountedPriceBadge from "../../quote/DiscountedPriceBadge"
import { DOCUMENT_TYPE } from "../../state/Constants"
import IntlProps from "../../state/helpers/IntlProps"
import { StockDocumentAttributes } from "../../state/inventory/stockdocument/models"
import { ORDER } from "../../state/order/Constants"
import { patchPricingTableItem } from "../../state/pricing/actions"
import { getPricingTableItem } from "../../state/pricing/selectors"
import { PRODUCT_TYPE } from "../../state/product/Types"
import { isBundleItem } from "../../utils/"
import { INVENTORY_STOCK_DIRECTION } from "../../utils/inventory"
import "../styles/main.scss"


type OwnProps = {
    itemId: string
    mainObjectId: string
    pricingTableId:string
    type: DOCUMENT_TYPE
    allowEdit: boolean
    shouldEditQuantity:boolean
    shouldEditPrice:boolean
    onUpdateCallback: () => void
    syncItemsWithCatalogPrices: boolean
    stockDocument?: StockDocumentAttributes
}

const PricePanelComponent = (props: Props & IntlProps) => {
    const [invoicedMeasure, setInvoicedMeasure] = useState(props.item?.attributes.invoicedMeasure || "0")
    const [measureProp, setMeasure] = useState(props.item?.attributes.measure || "0")
    const [additionalMeasure, setAdditionalMeasure] = useState(props.item?.attributes.additionalMeasure || "0")

    useEffect(() => {
        setInvoicedMeasure(props.item?.attributes.invoicedMeasure || "0")
        setMeasure(props.item?.attributes.measure || "0")
        setAdditionalMeasure(props.item?.attributes.additionalMeasure || "0")
    }, [props.item])

    const handleMeasureChange = (val: number | string) => {
        if (val && !isInvalidMeasureChange(val)) {
            let value=val
            if (props.stockDocument) {
                if (props.stockDocument &&
                    props.stockDocument.definition.attributes.direction != INVENTORY_STOCK_DIRECTION.IN_OUT &&
                    Number(val) < 0) {
                    value = "1"
                }
            }
            props.dispatch(patchPricingTableItem(props.itemId, props.mainObjectId, props.type, {
                measure: value,
                mainObjectId: props.mainObjectId,
            }, true, true))
            
            setInvoicedMeasure(value)
            setMeasure(value)
        } else {
            setInvoicedMeasure(invoicedMeasure)
        }
    }
    const handleAdditionalMeasureChange = (val: string | number) => {
        if (val) {
            props.dispatch(patchPricingTableItem(props.itemId, props.mainObjectId, props.type, {
                additionalMeasure: val,
                mainObjectId: props.mainObjectId,
            }, true, true))
        }
        setAdditionalMeasure(val)
    }
    const isInvalidMeasureChange = (val: string | number) => {
        return props.type === ORDER && Number(val) < Number(invoicedMeasure)
    }

    const isItemDiscounted = () => {
        if(props.item) {
            return props.item.attributes.isTaxInclusive ?
                parseFloat(props.item.attributes.calculatedUnitPrice as string) < parseFloat(props.item.attributes.unitPriceInclusive as string) :
                parseFloat(props.item.attributes.calculatedUnitPrice as string) < parseFloat(props.item.attributes.unitPrice as string)
        }
        return false
    }


    return (<div className="d-inline-flex flex-wrap ml-1">
        <div style={props.allowEdit ? { maxWidth: "100px", minWidth: "100px" } : {}} className="mt-1">
            {props.allowEdit ?
                <InputUnitOfMeasure
                    style={{
                        flex: "0 0 6em",
                    }}
                    debounced={true}
                    onChange={handleMeasureChange}
                    value={measureProp}
                    unit={props.item?.attributes.unitOfMeasure}
                    format={"short"}
                    className={"form-control-sm"}
                    groupClassName={"input-group-sm mr-2"}
                    disabled={props.item?.attributes.itemObject.attributes.type === PRODUCT_TYPE.BUNDLE || !props.shouldEditQuantity}
                /> : <>
                    <LabelUnitOfMeasure
                        unit={props.item?.attributes.unitOfMeasure}
                        value={props.item?.attributes.measure}
                    />
                    <span>&nbsp;&nbsp;x&nbsp;&nbsp;</span>
                </>}

            {props.item?.attributes.additionalMeasure && props.item.attributes.additionalMeasure !== "0" &&
                (props.allowEdit ? <InputUnitOfMeasure
                    style={{
                        flex: "0 0 6em"
                    }}
                    debounced={true}
                    onChange={handleAdditionalMeasureChange}
                    value={additionalMeasure}
                    unit={props.item?.attributes.additionalUnitOfMeasure}
                    format={"short"}
                    className={"form-control-sm"}
                    groupClassName={"input-group-sm mr-2 mt-2"}
                /> : <>
                    <LabelUnitOfMeasure
                        unit={props.item?.attributes.additionalUnitOfMeasure}
                        value={props.item?.attributes.additionalMeasure}
                    />
                    <span>&nbsp;&nbsp;x&nbsp;&nbsp;</span>
                </>)}
        </div>

        <div id={props.allowEdit ? "unitPriceItem" : "unitPriceItemModal"} >
            {props.item && !isBundleItem(props.item)  && <QuoteItemUnitPrice
                shortFormat={true}
                type={props.type}
                hideEditButtons={props.allowEdit}
                itemId={props.item.id}
                editable={props.allowEdit && props.shouldEditPrice}
                allowEdit={props.allowEdit}
                mainObjectId={props.mainObjectId} 
                syncItemsWithCatalogPrices={props.syncItemsWithCatalogPrices}
                stockDocument={props.stockDocument}
            />}
            {isItemDiscounted() && !isBundleItem(props.item) &&  <DiscountedPriceBadge
                unitPrice={props.item?.attributes.unitPrice}
                calculatedUnitPrice={props.item?.attributes.calculatedUnitPrice}
            />}

        </div>
    </div>)
}

const mapState = (state, props: OwnProps) => {
    const id = props.itemId
    const objectId = props.mainObjectId
    const item = getPricingTableItem(state, id, objectId)
    return {
        ...props,
        item: item,
    }
}
const connector = connect(mapState)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(PricePanelComponent))


// WEBPACK FOOTER //
// ./src/pricing/components/PricePanelComponent.tsx